import React, { useEffect, useState } from "react";
import axios from "axios";
import { RefreshCw, ShieldCheck, AlertTriangle } from "lucide-react";
import "./waba-report.css";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
export const wabaDate = value => value ? new Date(value).toLocaleString("ru-RU") : "Нет данных";

export const WabaDiagnostics = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const load = async () => {
    setLoading(true); setError("");
    try {
      const r = await axios.get(`${API}/admin/waba/diagnostics`, { withCredentials: true });
      setData(r.data);
    } catch (e) { setError(e.response?.data?.detail || "Не удалось проверить номера в Meta"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  return <section className="waba-diagnostics" data-testid="waba-diagnostics">
    <div className="waba-toolbar">
      <h3>Номера и подтверждения Meta</h3>
      <button type="button" className="waba-tool" data-testid="waba-diagnostics-refresh" disabled={loading} onClick={load}>
        <RefreshCw size={14} className={loading ? "animate-spin" : ""} /> {loading ? "Проверка Meta…" : "Проверить номера"}
      </button>
    </div>
    {error && <p role="alert" className="waba-danger" data-testid="waba-diagnostics-error">{error}</p>}
    <div className="waba-sender-grid">
      {(data?.items || []).map(s => <article key={s.id} className="waba-sender" data-testid={`waba-sender-health-${s.id}`}>
        <div className="waba-toolbar">
          <strong data-testid={`waba-sender-phone-${s.id}`}>{s.phone || s.label}</strong>
          <span className="waba-muted" data-testid={`waba-sender-role-${s.id}`}>{s.in_crm ? "Бутик · Mini CRM" : "Рассылки · вне CRM"}</span>
        </div>
        <div className="waba-muted" data-testid={`waba-sender-meta-name-${s.id}`}>{s.verified_name}</div>
        {s.error ? <p className="waba-danger" data-testid={`waba-sender-error-${s.id}`}>{s.error}</p> : <>
          <div className="waba-sender-facts" data-testid={`waba-sender-facts-${s.id}`}>
            <span>Подключение: <b>{s.connection || "неизвестно"}</b></span>
            <span>Качество: <b>{s.quality || "неизвестно"}</b></span>
            <span>Отправка: <b>{s.can_send || "неизвестно"}</b></span>
          </div>
          <div className={s.app_subscribed === false ? "waba-danger" : "waba-muted"} data-testid={`waba-sender-subscription-${s.id}`}>
            {s.app_subscribed ? <ShieldCheck size={14} /> : <AlertTriangle size={14} />} {s.app_subscribed === true ? "Приложение подписано на WABA" : s.app_subscribed === false ? "Нет подписки приложения на WABA" : "Подписка не подтверждена"}
          </div>
          <div className="waba-muted" data-testid={`waba-sender-waba-${s.id}`}>WABA: {s.waba_id || "не определён"}</div>
          {(s.warnings || []).map((text, i) => <p key={i} className="waba-warning" data-testid={`waba-sender-warning-${s.id}-${i}`}>{text}</p>)}
          <div className="waba-muted" data-testid={`waba-sender-last-webhook-${s.id}`}>Последний статус в этой базе: {wabaDate(s.last_webhook_at)}</div>
          <div className="waba-muted" data-testid={`waba-sender-last-inbound-${s.id}`}>Входящие от клиентов: {wabaDate(s.last_inbound_at)}{s.inbound_total ? ` · всего ${s.inbound_total}` : ""}</div>
        </>}
      </article>)}
    </div>
    {data && <div className="waba-muted" data-testid="waba-diagnostics-checked-at">Проверено: {wabaDate(data.checked_at)} · Настройки Meta не изменялись.</div>}
  </section>;
};